<template>
  <div class="room-label">
    <div class="room-label_icon-wrapper">
      <img
        :src="icon.src"
        class="room-label_icon"
        :alt="icon.alt"
      >
    </div>
    <span class="room-label_text">{{name}}</span>
  </div>
</template>

<script>
export default {
  name: 'room-label',

  data: () => ({

  }),

  props: {
    name: {
      type: String,
      require: true,
    },
    icon: {
      type: Object,
      require: true,
      default: {
        src: null,
        alt: null,
      },
    }
  },

  computed: {
  },
}
</script>

<style lang="sass">
.room-label
  display: flex
  align-items: center
  padding: px-em(10) px-em(24)
  background-color: #ECFAFB
  border-radius: px-em(30)
  font-weight: 900
  color: #1A4745

.room-label_icon-wrapper
  width: px-em(30)
  text-align: center
  line-height: 0
  margin-right: px-em(6)

.room-label_icon
  max-width: 100%

@media screen and (max-width: $mobile-breakpoint)
  .room-label
    font-size: 1em
    padding: px-em(10, 12) px-em(24, 12)
</style>
